<script>
    import { Line } from 'vue-chartjs'
    export default {
        extends: Line,
        name: "revenueBarChart",
        props: {
            // chartdata: Object,
            labels: Array,
            data: Array
        },
        data() {
            return {
                // loading: true,
                chartdata: {
                    labels: [],
                    datasets: [
                        // {
                        //   label: "Прибыль",
                        //   data: [],
                        //   backgroundColor: [
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //     'rgba(75, 192, 192, 0.2)',
                        //   ],
                        //   borderColor: [
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //     'rgba(75, 192, 192, 1)',
                        //   ],
                        //   borderWidth: 1
                        // },
                        // {
                        //   label: "Себестоимость",
                        //   data: [],
                        //   backgroundColor: [
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //     "rgba(255, 99, 132, 0.2)",
                        //   ],
                        //   borderColor: [
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //     "rgba(255, 99, 132, 1)",
                        //   ],
                        //   borderWidth: 1
                        // },
                        {
                            label: "Выручка",
                            data: [],
                            // backgroundColor: [
                            //     "#5087DE",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            //     "rgba(54, 162, 235, 0.2)",
                            // ],
                            // borderColor: [
                            //     "#5087DE",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            //     "rgba(54, 162, 235, 1)",
                            // ],
                            // borderWidth: 1
                        },
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'bottom',
                        align: 'start',
                        labels: {
                            boxWidth: 10,
                            boxHeight: 4,
                            fontSize: 14,
                            fontColor: '#000000',
                            padding: 30,
                            fontStyle: 'bold',
                            fontFamily: 'Gilroy',
                            usePointStyle: true
                        }
                    },

                    scales: {
                        fontFamily: 'Gilroy',

                        yAxes: [{
                            position: 'right',
                            ticks: {
                                min: 0,
                                fontFamily: 'Gilroy',
                                fontColor: '#000000',
                                fontStyle: 'bold',
                                fontSize: 11
                            },
                            gridLines: {
                                color: '#EAF0F4'
                            },

                        }],
                        xAxes: [{
                            ticks: {
                                fontFamily: 'Gilroy',
                                fontStyle: 'bold',
                                fontColor: '#0E254A',
                                padding: 15,
                                fontSize: 11
                            },
                            gridLines: {
                                color: '#EAF0F4'
                            },
                        }]
                    }
                }
            };
        },
        mounted() {
            // this.renderChart(this.chartdata, this.options);
        },
        watch: {
            // "chartdata":
            //   {
            //     handler: function () {
            //       this.renderChart(this.chartdata, this.options);
            //     },
            //     deep: true
            //   },
            "data": function() {
                this.chartdata.datasets[0].data = [];
                this.chartdata.labels = [];
                this.data.forEach(item => {
                    this.chartdata.datasets[0].data.push(item.value);
                    this.chartdata.labels.push(item.label);
                    this.chartdata.datasets[0].borderColor = '#5087DE';
                    this.chartdata.datasets[0].backgroundColor = 'rgba(80,135,222,0.3)';
                    this.chartdata.datasets[0].borderWidth = 2;
                });
                // // this.chartdata.datasets[0].data = this.data.profit;
                // this.chartdata.datasets[1].data = this.data.cost;
                // this.chartdata.datasets[0].data = this.data.revenue;
                //
                // this.chartdata.labels = this.data.dimension;
                this.renderChart(this.chartdata, this.options);
            }
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/apps/home/revenueBarChart.vue